import React, { useEffect, useMemo, useState } from 'react';

interface ICountdownTimer {
  date: string;
  endDate?: string;
}

export const CountdownTimer = ({ date, endDate }: ICountdownTimer) => {
  const targetDate = useMemo(() => new Date(date), []);

  const getTimeLeft = () => {
    const now = endDate ? new Date(endDate) : new Date();
    const difference = now.getTime() - targetDate.getTime();

    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
      };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);

    return {
      days,
      hours,
      minutes,
    };
  };

  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m
    </>
  );
};
